export default __webpack_public_path__ + "static/prism-7f90f64cbcc6b8c32c17d13babf0e524.jpg";